'use client'

import { useRouter } from 'next/navigation'
import { MdOutlineNotifications } from 'react-icons/md'

import ExitSurveyAlert from '../shared/exit-survey-alert'

import useGetNotificationCountQuery from '@/libs/apis/queries/use-get-notification-count-query'
import { usePreventExitSurvey } from '@/libs/hooks/use-prevent-exit-survey'

const NotificationBell = () => {
  const { push } = useRouter()
  const { data: notificationCountData } = useGetNotificationCountQuery()
  const { checkPreventStatus, showPreventAlert, setShowPreventAlert, dismiss } =
    usePreventExitSurvey()

  const onClick = () => {
    if (!checkPreventStatus()) {
      return push('/notifications')
    }
  }

  return (
    <>
      <ExitSurveyAlert
        isOpen={showPreventAlert}
        onClose={() => setShowPreventAlert(false)}
        onSubmit={() => {
          dismiss()
          setShowPreventAlert(false)
          return push('/notifications')
        }}
      />
      <button
        aria-label='bell'
        type='button'
        onClick={onClick}
        className='relative'
        data-testid='notification-bell-icon'
      >
        {notificationCountData?.result && notificationCountData?.result?.count > 0 && (
          <div
            data-testid='notification-badge'
            className='absolute right-1 top-1 h-2 w-2 rounded-full bg-pop-dodger-blue'
          />
        )}
        <MdOutlineNotifications data-testid='bell-icon' size={28} className='text-pop-grey-800' />
      </button>
    </>
  )
}

export default NotificationBell
